import { KampaayDataProvider } from 'services/api/dataProvider'
import { Location } from 'services/api/entities/catalog/location/types/internal/location-models'
import {
  parseCsvFields,
  parseMultilangUpsellingNames,
} from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'
import { formatHighlights } from './common'

export const locations: EntityDescriptor<Location> = {
  format:
    (_dataProvider?: KampaayDataProvider) =>
    ({ name, description, highlights, advanceReservationMin, ...record }) => ({
      id: record.id,
      ...parseCsvFields({ name, description }),
      'Booking time-limit': advanceReservationMin,
      highlights: formatHighlights(highlights),
      nickname: record.nickname,
      status: record.status,
      fullAddress: record.fullAddress,
      peopleCapacity: record.peopleCapacity,
      roomCapacity: record.roomCapacity,
      availableFrom: record.availableFrom,
      availableTo: record.availableTo,
      upselling: parseMultilangUpsellingNames(record.upsellingItemsFull),
    }),
}
